/**
 * Returns the enum value when the provided string matches one of the enum's values; otherwise `undefined`.
 * Useful when parsing untrusted inputs (e.g., query params) into typed enums.
 */
export function getValidEnumValue<EnumKey extends string, EnumValue extends string>(
  enumObject: Record<EnumKey, EnumValue>,
  value?: string | null,
): EnumValue | undefined {
  if (value && Object.values<string>(enumObject).includes(value)) {
    return value as EnumValue;
  }
  return undefined;
}

/**
 * Filters a list of strings, keeping only the entries that map to valid values of the provided enum.
 */
export function filterValidEnumValues<EnumKey extends string, EnumValue extends string>(
  enumObject: Record<EnumKey, EnumValue>,
  values: string[],
): EnumValue[] {
  const validated: EnumValue[] = [];
  for (const value of values) {
    if (Object.values<string>(enumObject).includes(value)) {
      validated.push(value as EnumValue);
    }
  }
  return validated;
}
